import React, { ReactNode } from 'react'

import { MultiLineText } from '@/components/common/i18n'

interface ITitleProps {
  children?: ReactNode
}

export const Title = (props: ITitleProps) => {
  return (
    <h2 className="ly-alert__tit">
      <MultiLineText>{props.children}</MultiLineText>
    </h2>
  )
}
